import { clearError, ClearErrorAction, setError, SetErrorAction } from './actions';

const initialState: string = null;

function errorReducer(state = initialState, { type, payload }: SetErrorAction | ClearErrorAction) {
	switch (type) {
		case setError.toString():
			return payload;
		case clearError.toString():
			return initialState;
		default:
			return state;
	}
}

export default errorReducer;
